import NormalIcon from '../StockItems/NormalIcon';
import { Icon } from '@iconify/react';
function App(props) {

  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var setItemEdited = props.setItemEdited;
  var isFEOrPU = props.isFEOrPU;
  var setBaselineMousePosition = props.setBaselineMousePosition;
  var error = props.error;
  var flashHighlight = props.flashHighlight;

  var feKeys = props.feKeys;
  var aFEKey = props.aFEKey;

  var defaultFE = currentList._g.ss;
  var fe = currentList[isFEOrPU];

//  

  function nullFn(){

  }
    var icons = [];

    if (isFEOrPU === 'fe'){

      if (feKeys.length > 1){
        if (defaultFE === aFEKey){
          icons.push({ic:'gis:route-start', t:'Start Page', f:nullFn});
        }else{
          function setAsStart(aFEKey){
            return function(e){
              var changes = [{t:'w',w:['_g','ss'],n:aFEKey}];
              organicChanges(changes);
            }
          }          
          var style = {};
          if (error && error.loc.join(' ') === 'noDefaultScreen'){
            if (flashHighlight && flashHighlight.i){
              style = {backgroundColor:'red'};
            }
          }
          icons.push({ic:'gis:route-end', t:'Set as Start Page', f:setAsStart(aFEKey), style});
        }
      }

    }

    function changeItemEdited(e){
      setItemEdited({t:'page', path:[isFEOrPU, aFEKey]});
    }

    icons.push({ic:'material-symbols:edit-square-outline', t:'Edit', f:changeItemEdited})

    var iconStretch = icons.map((anIcon,index)=>{
      var styleX = {};
      if (anIcon.style){
        styleX = anIcon.style;
      }
      return <NormalIcon icon={anIcon.ic} title={anIcon.t} isBrightWhenLit={true} height='30px' onClick={anIcon.f} style={styleX} />
    })


    function onMouseDown(e){
      setBaselineMousePosition({currentX:e.clientX, currentY:e.clientY, where:'dragMove', isFEOrPU, aFEKey});
      e.stopPropagation();
    }

//  
    var movePiece = <i className='qtip tip-bottom' data-tip='Move' ><div className='normalIconBright'><Icon height='25px' icon='carbon:move' onMouseDown={onMouseDown} style={{cursor:'pointer'}}/></div></i>
//

    var feHere = fe[aFEKey]



  function changePageName(e){
      var feHere = fe[aFEKey];
      var title = 'New Page Name?';
      if (isFEOrPU === 'pu'){
        title = 'New Pop-Up Name?'
      }
      var p = window.prompt(title, feHere.n);
      if (!p && p !== ''){
      }else{
        var pTrim = p.trim();
        if (pTrim){
          var changes = [{t:'w',w:[isFEOrPU, aFEKey, 'n'],n:pTrim}];
          organicChanges(changes);
        }else{
          window.alert('Blank names are not allowed');
        }
      }
    
  }

    return <table style={{margin:'5px'}}><tbody><tr>
            <td style={{whiteSpace:'nowrap'}}><p className="lead mb-0" style={{cursor:'pointer'}} onClick={changePageName}>{feHere.n}</p></td>
            <td style={{textAlign:'right', width:'100%'}}>{movePiece}{iconStretch}</td>
            </tr></tbody></table>


}

export default App;
